"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".outer-container[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto;width:50%;padding-top:50px;padding-bottom:50px}.outer-container[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .outer-container[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:5px}.outer-container[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{height:40px}\n/*# sourceMappingURL=validate-phone.component.css.map*/"];
exports.styles = styles;
